export enum FrequencyType {
  Daily = "jour(s)",
  Weekly = "semaine(s)",
  Monthly = "mois",
  Yearly = "année(s)"
}